import i18n, { Ti18nKeys } from "../../../../constants/i18n";
import ET3Circle from "../../../../core/et3-circle";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import getKhattabatStore from "../../../../stores/khattabat-stores";
import { E_CLIENT_PAGE, TClientPageType } from "../../../../Types";


export const PageTypeButton = withLiteObserverAndTheme<{
    type: TClientPageType;
}>((props) => {

    const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get()
    if (isAiKhattaba) {
        return <></>
    }

    const { theme, type } = props
    const { colors } = theme
    const isChosen = type === getKhattabatStore().getClientPageType.get()
    const isAllClients = type === E_CLIENT_PAGE.ALL
    const textKey: Ti18nKeys = isAllClients ? "ALL_CLIENTS" : "REQUIRES_ATTENTION"

    return (
        <ET3Div
            width={350}
            height={100}
            alignItems={"center"}
            fDirection={"column"}
            style={{}}
            color={""}
            justifyContent={"center"}
            withShadow={false}
            isExtendable={false}
            isScrollable={false}
            onClick={() => { }}
        >
            <ET3Circle
                size={20}
                style={{
                    border: `2px solid ${colors.all.dimGray}`,
                    backgroundColor: isChosen ? colors.all.green : colors.all.transparent,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer"
                }}
                color={""}
                withShadow={true}
                onClick={() => getKhattabatStore().setClientPageType(type)}
            />

            <Et3Margin top={5} bottom={0} left={0} right={0} />
            <Et3Text
                fontFamily={"MEDIUM"}
                fontSize={25}
                isSpan={true}
                text={i18n.get(textKey)}
                style={{}}
                color={""}
            />
        </ET3Div>
    )
})

export default PageTypeButton